<script setup lang="ts">
import { GoalPositionIndicator, PitchPositionIndicator } from './indicators'
import type {
  GoalPosition,
  PitchDistance,
  PitchPosition,
} from './indicators/PitchPositionIndicator/types'

type Props = {
  goalPositionDisabled?: boolean
  pitchPositionDisabled?: boolean
}

defineProps<Props>()

// model
const goalPosition = defineModel<GoalPosition>('goalPosition', {
  default: null,
})
const pitchDistance = defineModel<PitchDistance>('pitchDistance', {
  default: null,
})
const pitchPosition = defineModel<PitchPosition>('pitchPosition', {
  default: null,
})
</script>

<template>
  <div class="flex flex-col items-center">
    <GoalPositionIndicator
      v-model="goalPosition"
      :disabled="goalPositionDisabled"
    />
    <PitchPositionIndicator
      v-model:pitchDistance="pitchDistance"
      v-model:pitchPosition="pitchPosition"
      :disabled="pitchPositionDisabled"
    />
  </div>
</template>
